import React, { PropsWithChildren, useState } from "react";

import Button from "../../../../../../../components/Button";
// components
import ContentModal from "../../../../../../../components/Modal/Templates/ContentModal";
import Spacer from "../../../../../../../components/Spacer";
import Typography from "../../../../../../../components/Text";
import { TextEditor } from "../../../../../../../components/TextEditor";

import css from "./CompleteGoalsModal.module.scss";

type CompleteGoalsModalProps = {
	numberOfGoals: number;
	onClose?: () => void;
	onUpdate?: (message: string) => void;
};

const CompleteGoalsModal = ({ numberOfGoals = 0, onClose, onUpdate }: PropsWithChildren<CompleteGoalsModalProps>) => {
	const [message, setMessage] = useState("");
	if (onUpdate && onClose) {
		return (
			<ContentModal
				size="large"
				handleClose={onClose}
				buttons={[
					<Button size="large" key="negative" color="blue" onClick={onClose}>
						Cancel
					</Button>,
					<Button
						size="large"
						key="positive"
						color="green"
						disabled={numberOfGoals === 0}
						onClick={() => {
							onUpdate(message);
							onClose();
						}}
					>
						Yes, Complete Goal{numberOfGoals !== 1 ? "s" : ""}
					</Button>,
				]}
			>
				<Typography className={css.completeHeader} size="paragraph-1" weight="semi-bold">
					Performing this action will complete {numberOfGoals} goal{numberOfGoals !== 1 ? "s" : ""}. Are you
					sure you want to proceed?
				</Typography>
				<Spacer height={2} />
				<Typography className={css.completeHeader} size="paragraph-3" weight="regular">
					Please note, only Active goals will be affected.
				</Typography>
				<Spacer height={2} />
				<TextEditor
					id="complete-goals-message"
					label="Message"
					labelProps={{ size: "paragraph-3", weight: "semi-bold" }}
					className={css.messageContainer}
					placeholder="Enter a message to be recorded for each completed goal..."
					onChange={(value) => setMessage(value)}
				></TextEditor>
			</ContentModal>
		);
	}
};

export default CompleteGoalsModal;
